
import styled from 'styled-components';

const StyledHiddenUploadInput = styled.input`
  display: none;
  width: 1px;
  height: 1px;
  position: absolute;
  z-index: -1;
`;

export { StyledHiddenUploadInput };
